import { Tabs } from 'antd';
import * as React from 'react';
import type { TabsProps } from 'antd';
import { INodeInfo } from '../index';
import Param from './Param';
import Control from './Control';
import Status from './Status';

interface INodeDetailPanelProps {
    isShow: boolean;
    selectedNode: INodeInfo | null;
    handleCancel: () => void;
}

const NodeDetailPanel: React.FunctionComponent<INodeDetailPanelProps> = ({ 
    isShow, 
    selectedNode, 
    handleCancel 
}) => {
    if (!selectedNode) return null;

    const NODE_DETAIL_TAB_LIST: TabsProps['items'] = [
        {
            key: '1',
            label: 'Thông tin',
            children: (
                <Param selectedNode={selectedNode} />
            ),
        },
        {
            key: '2',
            label: 'Trạng thái thời gian thực',
            children: (
                <Status nodeId={selectedNode?.nodes.id.toString() || ''} />
            ),
        },
        {
            key: '3',
            label: 'Điều khiển',
            children: (
                <Control selectedNode={selectedNode} />
            ),
        },
    ];

    const onChange = (key: string) => {
        // console.log(key);
    };

    return (
        <>
            {/* Sliding Panel */}
            <div 
                className={`fixed top-0 right-0 h-full w-[40%] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out bg-neutral-White ${
                    isShow ? 'translate-x-0' : 'translate-x-full'
                }`}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <h2 className="text-lg font-semibold text-gray-800">
                        Node: {selectedNode?.nodes.serialNumber || 'Node Details'}
                    </h2>
                    <button
                        onClick={handleCancel}
                        className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
                    >
                        <svg 
                            className="w-5 h-5 text-gray-500" 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                        >
                            <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth={2} 
                                d="M6 18L18 6M6 6l12 12" 
                            />
                        </svg>
                    </button>
                </div>
                
                {/* Content */}
                <div className="h-full overflow-y-auto">
                    <Tabs 
                        defaultActiveKey="1" 
                        items={NODE_DETAIL_TAB_LIST} 
                        onChange={onChange}
                        className="px-4"
                    />
                </div>
            </div>
        </>
    );
};

export default NodeDetailPanel; 